import { NgxSpinnerService } from 'ngx-spinner';
import { ProcessControl } from './../../models/processcontrol/processControl';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProcessControlService } from 'src/app/services/process-control.service';
import { WebSocketService } from 'src/app/services/web-socket.service';
import { RoleService } from 'src/app/services/role.service';
import { StorageUtil } from 'src/app/utils/storage.util';
import { MessageUtil } from 'src/app/utils/message.util';
import { HttpClient } from '@angular/common/http';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { ResultDialogComponent } from 'src/app/pages/billing/billets-management/outfile/result-dialog/result-dialog.component';
import { ResultDialogInvoiceComponent } from './result-dialog-invoice/result-dialog-invoice.component';
import { EnotasNfeGenerateResultDialogComponent } from './enotas-nfe-generate-result-dialog/enotas-nfe-generate-result-dialog.component';
import { BilletGenerateResultDialogComponent } from './billet-generate-result-dialog/billet-generate-result-dialog.component';
import { InvoiceCancelResultDialogComponent } from './invoice-cancel-result-dialog/invoice-cancel-result-dialog.component';
import { ProcessControlType } from 'src/app/models/enums/process-control-type.enum';

@Component({
  selector: 'app-process-control-form',
  templateUrl: './process-control-form.component.html',
  styleUrls: ['./process-control-form.component.scss'],
})
export class ProcessControlFormComponent implements OnInit {
  listaProcessos: ProcessControl[] = [];

  private processSubscription: Subscription;

  isDeveloper = false;

  constructor(
    private processControlService: ProcessControlService,
    private spinner: NgxSpinnerService,
    private webSocketService: WebSocketService,
    private roleService: RoleService,
    public messageUtil: MessageUtil,
    private http: HttpClient,
    private dialog: DialogService
  ) {}

  ngOnInit() {
    this.getProcessos();
    this.checkIfUserIsDeveloper();
    this.processSubscription = this.webSocketService
      .getProcessControl()
      .subscribe(async (message) => {
        this.spinner.show();
        this.getProcessos();
        this.spinner.hide();
      });
  }

  private convertUTCToLocalDate(date: Date | string): Date {
    if (!date) return null;
    const utcDate = new Date(date);
    return new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60000));
  }

  getProcessos() {
    this.processControlService.getAll().subscribe({
      next: (resp) => {
        this.listaProcessos = resp.map(process => ({
          ...process,
          startDate: this.convertUTCToLocalDate(process.startDate),
          endDate: this.convertUTCToLocalDate(process.endDate)
        }));
      },
      error: (error) => {
        // Swal.fire('Atenção', 'Erro ao Recuperar imformações', 'warning');
      },
    });
  }

  download(file: string, process: ProcessControl) {
    if (!file) {
      return;
    }
    const description = process?.description;
    const type = process?.type as ProcessControlType | string | undefined;
    const isJson = this.filePath(file).toLowerCase().endsWith('.json');

    if (type === ProcessControlType.ENOTAS_NFE_GENERATE && isJson) {
      this.http
        .get(file, {
          responseType: 'text',
          headers: { Accept: 'application/json, text/plain, */*' },
        })
        .subscribe({
          next: (response: string) => {
            try {
              const data = JSON.parse(response);
              this.dialog.open(EnotasNfeGenerateResultDialogComponent, {
                width: '80%',
                height: '85%',
                dismissableMask: false,
                data,
                header: this.messageUtil.translateKey('ENOTAS-NFE-GENERATE-DETAIL-TITLE'),
              });
            } catch (parseError) {
              console.error('Erro ao fazer parse do JSON eNotas NF:', parseError);
              window.open(`${file}`, '_blank').focus();
            }
          },
          error: () => window.open(`${file}`, '_blank').focus(),
        });
      return;
    }

    if (type === ProcessControlType.INVOICE_CANCEL && isJson) {
      this.http
        .get(file, {
          responseType: 'text',
          headers: { Accept: 'application/json, text/plain, */*' },
        })
        .subscribe({
          next: (response: string) => {
            try {
              const data = JSON.parse(response);
              this.dialog.open(InvoiceCancelResultDialogComponent, {
                width: '85%',
                height: '90%',
                dismissableMask: false,
                data,
                header: 'Detalhes do Cancelamento de Faturas em Lote',
              });
            } catch (parseError) {
              console.error('Erro ao fazer parse do JSON do cancelamento em lote:', parseError);
              window.open(`${file}`, '_blank').focus();
            }
          },
          error: () => window.open(`${file}`, '_blank').focus(),
        });
      return;
    }

    if (type === ProcessControlType.BILLET_GENERATE && isJson) {
      this.http
        .get(file, {
          responseType: 'text',
          headers: { Accept: 'application/json, text/plain, */*' },
        })
        .subscribe({
          next: (response: string) => {
            try {
              const data = JSON.parse(response);
              this.dialog.open(BilletGenerateResultDialogComponent, {
                width: '80%',
                height: '85%',
                dismissableMask: false,
                data,
                header: 'Detalhes da Geração de Boletos',
              });
            } catch (parseError) {
              console.error('Erro ao fazer parse do JSON de boletos:', parseError);
              window.open(`${file}`, '_blank').focus();
            }
          },
          error: () => window.open(`${file}`, '_blank').focus(),
        });
      return;
    }

    const isReturnImport = this.isReturnFileImport(process);
    if ((isReturnImport && isJson) || description === 'Geração de Fatura.') {
      this.http
        .get(file, {
          responseType: 'text',
          headers: { Accept: 'application/json, text/plain, */*' },
        })
        .subscribe({
          next: (response: string) => {
            try {
              const data = JSON.parse(response);
              if (description === 'Geração de Fatura.') {
                this.dialog.open(ResultDialogInvoiceComponent, {
                  width: '75%',
                  height: '80%',
                  dismissableMask: false,
                  data,
                  header: 'Detalhes da Geração de Fatura',
                });
              } else {
                this.dialog.open(ResultDialogComponent, {
                  width: '75%',
                  height: '80%',
                  dismissableMask: false,
                  data,
                  header: 'Resultado de importação do banco ',
                });
              }
            } catch (parseError) {
              console.error('Erro ao fazer parse do JSON:', parseError);
              window.open(`${file}`, '_blank').focus();
            }
          },
          error: () => window.open(`${file}`, '_blank').focus(),
        });
      return;
    }
    window.open(`${file}`, '_blank').focus();
  }

  downloadLog(process: ProcessControl) {
    const jsonUrl = process?.urlFile1;
    if (this.isReturnFileImport(process) && jsonUrl) {
      // SEC-4817: com link temporário do S3 o .txt vem pronto do backend; trocar o fim da URL do .json
      // invalidaria a assinatura. A troca fica só como reserva para resposta sem o campo novo.
      const url = process.urlFile1Txt || jsonUrl.replace(/\.json$/, '.txt');
      window.open(`${url}`, '_blank').focus();
      return;
    }
    if (process?.type === ProcessControlType.ENOTAS_NFE_GENERATE && process.urlFile2) {
      window.open(`${process.urlFile2}`, '_blank').focus();
      return;
    }
    if (jsonUrl) {
      window.open(`${jsonUrl}`, '_blank').focus();
    }
  }

  showReturnImportLogShortcut(process: ProcessControl): boolean {
    return this.isReturnFileImport(process);
  }

  /**
   * O processo de importação de retorno passou a ser criado pelo api2, que grava a
   * descrição com o nome do arquivo ('Importação arquivo de Retorno: ARQ.RET') em vez
   * do texto fixo usado pelo api1 ('Importação arquivo de Retorno.'). Comparar a
   * descrição por igualdade derrubava o modal de resultado e o atalho do log texto.
   * O tipo do processo é o mesmo nos dois back-ends, então é ele que manda.
   */
  isReturnFileImport(process: ProcessControl): boolean {
    if (!process) {
      return false;
    }
    return (
      process.type === ProcessControlType.RETURN_FILE_IMPORT ||
      (process.description || '').startsWith('Importação arquivo de Retorno')
    );
  }

  isLogFile(fileUrl: string): boolean {
    if (!fileUrl) {
      return false;
    }
    const path = this.filePath(fileUrl);
    return (
      path.endsWith('logBoletos.txt') ||
      path.endsWith('logInvoice.txt') ||
      path.endsWith('logNfeEnotas.txt')
    );
  }

  /**
   * SEC-4817: o api2 pode devolver o arquivo como link temporário do S3, com a assinatura na query
   * (`...arquivo.json?X-Amz-...`). O tipo do arquivo sai do caminho, sem a query.
   */
  private filePath(fileUrl: string): string {
    return fileUrl.split('?')[0];
  }

  shouldDisplayFile(fileUrl: string): boolean {
    if (!fileUrl) {
      return false;
    }
    if (this.isLogFile(fileUrl)) {
      return this.isDeveloper;
    }
    return true;
  }

  checkIfUserIsDeveloper() {
    const userId = StorageUtil.getUserId();
    this.roleService.isDeveloper(userId).subscribe({
      next: (isDeveloper) => {
        this.isDeveloper = isDeveloper;
      },
      error: (error) => {
        console.error('Erro ao verificar se o usuário é desenvolvedor:', error);
        this.isDeveloper = false;
      }
    });
  }
}
